import { render, staticRenderFns } from "./UserAddressTables.vue?vue&type=template&id=4e9e013c"
import script from "./UserAddressTables.vue?vue&type=script&lang=js"
export * from "./UserAddressTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports